import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { RefreshCwIcon } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { DataTable } from '@/components/DataTable';
import { Button } from '@/components/ui/button';
import { terraformBackendBucketsQueries } from '@/lib/queries/integrations/terraformBackend/buckets';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { getColumns } from './-columns';

export const Route = createFileRoute(
  '/_root/integrations/terraform-backend/buckets/',
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    const defaultProject = await preLoadDefaultProject({ context });
    context.queryClient.prefetchQuery(
      terraformBackendBucketsQueries.list(defaultProject.id),
    );

    return defaultProject;
  },
});

function RouteComponent() {
  const defaultProject = Route.useLoaderData();
  const { queryClient } = Route.useRouteContext();

  const { data: buckets } = useSuspenseQuery(
    terraformBackendBucketsQueries.list(defaultProject.id),
  );

  return (
    <div className="h-full flex flex-col pb-24">
      <h1 className="text-3xl mb-6">
        <FormattedMessage id="integrations.terraformBackend.buckets.title" />
      </h1>
      <p className="mb-6">
        <FormattedMessage id="integrations.terraformBackend.buckets.cta" />
      </p>
      <div className="flex flex-row items-baseline">
        <h2 className="text-2xl">
          <FormattedMessage id="integrations.terraformBackend.buckets.list.title" />
        </h2>
        <Button
          variant="ghost"
          className="ml-2 h-8 w-8 p-0"
          onClick={() => {
            queryClient.invalidateQueries(
              terraformBackendBucketsQueries.list(defaultProject.id),
            );
          }}
        >
          <RefreshCwIcon className="h-4 w-4" />
        </Button>
      </div>
      <DataTable
        columns={getColumns()}
        data={buckets.filter(b => b.syncStatus !== 'unsynced-with-code')}
        headersTranslationPath="integrations.terraformBackend.buckets.list.table"
      />
    </div>
  );
}
